var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFilters,
              expression: "showFilters"
            }
          ],
          staticClass: "col-4"
        },
        [
          _c(
            "q-scroll-area",
            { staticStyle: { width: "100%", height: "calc(100vh - 106px)" } },
            [
              _c("card-search-filter-files", {
                ref: "cardSearchFilterFiles",
                on: {
                  fetch: _vm.fetchData,
                  changeproject: _vm.changeProject,
                  changepath: _vm.changePath
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "q-scroll-area",
            { staticStyle: { width: "100%", height: "calc(100vh - 106px)" } },
            [
              _c(
                "q-breadcrumbs",
                [
                  _c("q-breadcrumbs-el", {
                    staticClass: "cursor-pointer",
                    attrs: { icon: "home", color: "secondary" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.breadcrumbClick({ path: "" })
                      }
                    }
                  }),
                  _vm._l(_vm.bradcrumbPath, function(item) {
                    return _c("q-breadcrumbs-el", {
                      key: item.path,
                      staticClass: "cursor-pointer",
                      attrs: { label: item.folder, color: "secondary" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.breadcrumbClick(item)
                        }
                      }
                    })
                  })
                ],
                2
              ),
              _c("q-table", {
                attrs: {
                  title: _vm.tableTitle,
                  data: _vm.items,
                  columns: _vm.getColumns,
                  "row-key": "_oid",
                  pagination: _vm.pagination,
                  "rows-per-page-options": _vm.rowsPerPage,
                  separator: "horizontal",
                  filter: _vm.tableFilter,
                  dense: ""
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "top-left",
                    fn: function(props) {
                      return [
                        _c("q-toggle", {
                          attrs: { icon: "input" },
                          model: {
                            value: _vm.showFilters,
                            callback: function($$v) {
                              _vm.showFilters = $$v
                            },
                            expression: "showFilters"
                          }
                        }),
                        _c(
                          "q-btn-group",
                          { staticClass: "q-ml-md", attrs: { rounded: "" } },
                          [
                            _vm.asdialog
                              ? _c("q-btn", {
                                  attrs: {
                                    rounded: "",
                                    color: "primary",
                                    icon: "attach_file",
                                    label: "wybierz"
                                  },
                                  on: { click: _vm.onAttach }
                                })
                              : _vm._e(),
                            _c("q-btn", {
                              attrs: {
                                rounded: "",
                                color: "primary",
                                icon: "upload_file",
                                label: "wgraj"
                              },
                              on: { click: _vm.onUpload }
                            }),
                            _c("q-btn", {
                              attrs: {
                                rounded: "",
                                color: "primary",
                                icon: "create_new_folder",
                                label: "dodaj folder"
                              },
                              on: { click: _vm.onNewFolder }
                            }),
                            _vm.asdialog
                              ? _c("q-btn", {
                                  attrs: {
                                    rounded: "",
                                    color: "info",
                                    icon: "close",
                                    label: "zamknij"
                                  },
                                  on: { click: _vm.onClose }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "top-right",
                    fn: function(props) {
                      return [
                        _c("q-search", {
                          staticClass: "col-6",
                          attrs: {
                            "hide-underline": "",
                            color: "secondary",
                            placeholder: "filtruj.."
                          },
                          model: {
                            value: _vm.tableFilter,
                            callback: function($$v) {
                              _vm.tableFilter = $$v
                            },
                            expression: "tableFilter"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "body-cell-_cid",
                    fn: function(props) {
                      return _c(
                        "q-td",
                        { attrs: { props: props } },
                        [
                          _c(
                            "q-btn",
                            {
                              attrs: {
                                round: "",
                                dense: "",
                                icon: "edit",
                                color: "primary",
                                size: "sm"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.objectClick(props.row)
                                }
                              }
                            },
                            [
                              !_vm.$q.platform.is.mobile
                                ? _c("q-tooltip", [
                                    _vm._v("przejdź do obiektu")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }
                  },
                  {
                    key: "body-cell-_oid",
                    fn: function(props) {
                      return _c("q-td", { attrs: { props: props } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(props.value) +
                            "\n            "
                        )
                      ])
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }